const func = $target => {
    var $videoModal = $target.find('.modal'),
        modalSrc = $videoModal.find('iframe').attr('src');
        $body = $('body');

        $videoModal
            .on('show.bs.modal', function (e) {

                var $iframe = $(this).find('iframe');

                $body.addClass('modal-backdrop-media');
                if ($iframe.length > 0) {
                    $iframe.attr('src', modalSrc + '&autoplay=1');
                }
            })
            .on('hidden.bs.modal', function (e) {
                var $modalIframe = $(this).find('iframe');
                $body.removeClass('modal-backdrop-media');
                if ($modalIframe.length > 0) {
                    $modalIframe.attr('src', '');
                }
            });

};
export default func;


